import React, { Suspense, lazy } from 'react';
import { Provider,connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './styles/main.scss';

import Loader from './components/common/loader';
const Search = lazy(() => import('./components/search'));
const Stopage = lazy(() => import('./components/search/stopage'));
const Slider = lazy(() => import('./components/common/slider'));

const App = ({ store ,loader}) => (
  <Provider store = {store}>
    <Router>
        <Suspense fallback = { <Loader /> }>
          <Switch>
            <Route exact path = "/:token" component = { Search } />
            <Route path = "/stopage/:token" component = { Stopage } />
            <Route path = "/" component = { ErrorPage } />
          </Switch>
        </Suspense>
    </Router>
   </Provider>
)

const ErrorPage = () => (
  <div className = 'err-screen'>
    Oops! some error occured! Token is required to open the gps screen! 
    <br />
    <br />
  </div>
)

const mapStateToProps = store => ({
	loader: store.loader
})

export default connect(mapStateToProps)(App);
